import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./style.module.scss";
import DropDownMenu from "../DropDownMenu";
import InlineHelp from "../InlineHelp";
import Icon from "../Icon";
export default function ContainerHeader(props) {
    const { title, rumIcon, synIcon, dropdownConfig, description, inlineHelp, children } = props;
    //Only render the dropdown if it's enabled.
    function dropDown() {
        return dropdownConfig ? _jsx(DropDownMenu, Object.assign({}, dropdownConfig)) : null;
    }
    const iconCont = [];
    if (rumIcon) {
        iconCont.push(_jsx(InlineHelp, { info: "Real User Monitoring data", children: _jsx(Icon, { name: "rum" }) }));
    }
    if (synIcon) {
        iconCont.push(_jsx(InlineHelp, { info: "Synthetic testing data", children: _jsx(Icon, { name: "syn" }) }));
    }
    const descriptionCont = [];
    if (description) {
        descriptionCont.push(_jsx("div", { className: "container-header__description", children: description }));
    }
    return (_jsxs("div", { className: "container-header", children: [_jsxs("div", { className: "container-header__top", children: [_jsxs("div", { className: "container-header__title", children: [title, dropDown(), _jsx(InlineHelp, { info: inlineHelp }), _jsx("span", { className: "container-header__icons", children: iconCont })] }), _jsx("div", { children: children })] }), descriptionCont] }));
}
